import { Button } from "@/components/button/Button"
import { Sidepanel } from "@/components/sidepanel/Sidepanel"
import { Form } from "@/components/ui/form"
import { InputField } from "@/components/ui/form/InputField"
import { tasksApi } from "@/fetch/api/tasks"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import styled from "styled-components"

const ButtonRow = styled.div`
  display: flex;
  margin: 10px;
  justify-content: flex-end;
  gap: 8px;
`
const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: -0.02em;
  text-align: left;
  margin-bottom: 20px;
`

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`

type FormInputs = {
  name: string
}

export const AddNewOperation = ({ onClose }: { onClose?: () => void }) => {
  const [open, setOpen] = useState(false)
  const form = useForm<FormInputs>()

  const handleClose = () => {
    setOpen(false)
  }

  const onSubmit = async (values: FormInputs) => {
    try {
      await tasksApi.createOperationGroup(values)
      setOpen(false)
      onClose?.()
      toast("Grupa veigsmīgi izveidota", { type: "success" })
    } catch {
      toast("Grupa nav izveidota, lūdzu mēģiniet vēlreiz", { type: "error" })
    }
  }

  // Adding new task/process entries is disabled.
  return null

  // eslint-disable-next-line no-unreachable
  return (
    <>
      <Button onClick={() => setOpen(true)}>Pievienot procesu</Button>
      <Sidepanel open={open} onClose={handleClose}>
        <Title>Pievienot jaunu procesu</Title>
        <Form {...form}>
          <StyledForm onSubmit={form.handleSubmit(onSubmit)}>
            <InputField
              control={form.control}
              name="name"
              placeholder="Nosaukums"
              label="Nosaukums"
            />
            <ButtonRow>
              <Button
                variant="secondary"
                type="button"
                onClick={() => setOpen(false)}
              >
                Atcelt
              </Button>
              <Button type="submit">Pievienot</Button>
            </ButtonRow>
          </StyledForm>
        </Form>
      </Sidepanel>
    </>
  )
}
